const packs1 = require("./packs1.json");
const packs2 = require("./packs2.json");
const repositories1 = require("./repositories1.json");
const semver = require("semver");

const DB = require("./service");

const packs = [...packs1.items, ...packs2.items];

const db = new DB({ packs, repositories: repositories1.items });

function getVersions({ name, registryUid }) {
  const items = db.collection("packs").filter((item) => {
    return item.spec.name === name && item.spec.registryUid === registryUid;
  });

  if (!items.length) {
    return { tags: [], packValues: [] };
  }

  const tags = items.reduce((accumulator, item) => {
    function appendIfMissing(tag) {
      const found = accumulator.find(
        (existingTag) => existingTag.tag === tag.tag,
      );

      if (found) {
        if (semver.gt(tag.version, found.version)) {
          found.version = tag.version;
        }

        return;
      }

      accumulator.push(tag);
    }

    const version = item.spec.version;
    const [major, minor] = version.split(".");
    const patchVersion = [major, minor, "x"].join(".");
    const minorVersion = [major, "x"].join(".");
    const packUid = item.metadata.uid;

    appendIfMissing({
      packUid,
      parentTags: [patchVersion, minorVersion],
      tag: version,
      version,
    });

    appendIfMissing({
      packUid,
      parentTags: [minorVersion],
      tag: patchVersion,
      version,
    });

    appendIfMissing({
      packUid,
      parentTags: null,
      tag: minorVersion,
      version,
    });

    return accumulator;
  }, []);

  const packValues = items.reduce((accumulator, item) => {
    accumulator.push({
      packUid: item.metadata.uid,
      values: item.spec.values,
    });

    return accumulator;
  }, []);

  return {
    ...items[0].metadata,
    tags,
    packValues: packValues,
  };
}

module.exports = db;
module.exports.getVersions = getVersions;
